export default  {"src":"/_next/static/image/public/logo-poweredby.464308bb34abe030c5190596557a8684.svg","height":43,"width":125};